/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Positionierung und Verhalten von Personalisierungs Containern

document.addEventListener("DOMContentLoaded", function() {
 
    let button1 = document.querySelector('.product-form__add-button');
    let button2 = document.querySelector('.spiff-button');
    let paymentContainer = document.querySelector('.product-form__payment-container');

    // Wenn button2 und paymentContainer existieren, verschiebe button2 in paymentContainer
    if (button2 && paymentContainer) {
        paymentContainer.appendChild(button2);
    }

    // Positioniere den paymentContainer und die Buttons
    if (paymentContainer) {
        paymentContainer.style.position = 'relative';
    }

    if (button1) {
        button1.style.position = 'relative';
        button1.style.zIndex = '2';
    }

    if (button2) {
        button2.style.position = 'absolute';
        button2.style.top = '0';
        button2.style.left = '0';
        button2.style.zIndex = '1';
    }

    // Wenn das Produkt nicht verfügbar ist und der spiff-button existiert, blende ihn aus
    if (!isAvailable && button2) {
        button2.style.cssText = "display: none !important;";
    }

    // Überprüfe, ob beide Buttons vorhanden sind, bevor der Rest des Codes ausgeführt wird
    if (button1 && button2) {
        // Setze die Breite und Höhe von Button 2 auf die von Button 1
        let widthButton1 = getComputedStyle(button1).width;
        let heightButton1 = getComputedStyle(button1).height;
        button2.style.width = widthButton1;
        button2.style.height = heightButton1;  
    }
  
    let container1 = document.getElementById('container1');
    let container2 = document.getElementById('container2');

    if (container1 && container2) {
        container1.addEventListener('click', function() {
            button1.style.visibility = 'visible';
            if (button2) button2.style.visibility = 'hidden';
            container1.classList.add('selected');
            container2.classList.remove('selected');
        });

        container2.addEventListener('click', function() {
            button1.style.visibility = 'hidden';
            if (button2) button2.style.visibility = 'visible';
            container2.classList.add('selected');
            container1.classList.remove('selected');
        });
    }
});